import logo from '@assets/images/logo.png';
import city from '@assets/images/city.jpg';
import lounge from '@assets/images/lounge.png';
import loginLounge from '@assets/images/loginLounge.jpg';
import loungeDemo from '@assets/images/loungeDemo.png';
import loungeLeela from '@assets/images/loungeLeela.svg';

export const images = {
  logo,
  city,
  lounge,
  loginLounge,
  loungeDemo,
  loungeLeela,
};
